import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RequestsUtilityService {
  constructor() {}

  public bearerToken(token: string):  HttpHeaders  {
    return new HttpHeaders({
        "Authorization": `Bearer ${token}`,
      });
  }
}
